document.addEventListener('DOMContentLoaded', () => {
  const UpsellSystem = {
    config: {
      checkboxSelector: '.upsell-product-checkbox',
      bundleButtonId: 'add-upsell-bundle',
      discountText: '10% OFF',
      cartCheckInterval: 5000,
      errorDisplayTime: 3000,
    },

    elements: {
      checkboxes: null,
      bundleButton: null,
    },

    init() {
      this.elements.checkboxes = document.querySelectorAll(this.config.checkboxSelector);
      this.elements.bundleButton = document.getElementById(this.config.bundleButtonId);

      if (this.elements.checkboxes.length) {
        this.initUpsellBasket();
      }

      if (this.elements.bundleButton) {
        this.initAddBundleButton();
      }
    },

    initUpsellBasket() {
      this.syncCheckboxesWithCart();

      this.elements.checkboxes.forEach(checkbox => {
        checkbox.setAttribute('data-initial-state', checkbox.checked ? 'checked' : 'unchecked');
        checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
      });

      this.listenForCartChanges();
    },

    syncCheckboxesWithCart(callback) {
      Shopify.getCart(cart => {
        this.elements.checkboxes.forEach(checkbox => {
          const variantId = checkbox.getAttribute('data-variant-id');
          const isInCart = cart.items.some(item => item.id.toString() === variantId.toString());

          checkbox.checked = isInCart;
          checkbox.setAttribute('data-initial-state', isInCart ? 'checked' : 'unchecked');
        });

        // ✅ Update the bundle button state
        this.updateBundleButtonState?.();

        // ✅ Call the callback if provided
        if (typeof callback === 'function') {
          callback();
        }
      });
    },
    listenForCartChanges() {
      let observerSet = false;

      if (window.theme && theme.miniCart) {
        const cartContainer = document.querySelector('.js-mini-cart-content');

        if (cartContainer) {
          const observer = new MutationObserver(() => {
            this.syncCheckboxesWithCart();
          });

          observer.observe(cartContainer, {
            childList: true,
            subtree: true
          });

          observerSet = true;
        }
      }

      const miniCart = document.querySelector('.js-mini-cart');
      if (miniCart) {
        miniCart.addEventListener('click', () => {
          this.syncCheckboxesWithCart();
        });

        observerSet = true;
      }

      if (!observerSet) {
        setInterval(() => this.syncCheckboxesWithCart(), this.config.cartCheckInterval);
      }
    },

    handleCheckboxChange(event) {
      const checkbox = event.target;
      const variantId = checkbox.getAttribute('data-variant-id');
      const isChecked = checkbox.checked;

      this.UI.showLoader(checkbox);

      if (isChecked) {
        this.Cart.addProduct(variantId, 1)
          .then(() => {
            this.UI.hideLoader(checkbox);
            checkbox.setAttribute('data-initial-state', 'checked');
          })
          .catch(error => {
            console.error('Error adding product to cart:', error);
            checkbox.checked = false;
            this.UI.hideLoader(checkbox);
            this.UI.showError(checkbox, 'Failed to add product');
          });
      } else {
        this.Cart.removeProduct(variantId)
          .then(() => {
            this.UI.hideLoader(checkbox);
            checkbox.setAttribute('data-initial-state', 'unchecked');
          })
          .catch(error => {
            console.error('Error removing product from cart:', error);
            checkbox.checked = true;
            this.UI.hideLoader(checkbox);
            this.UI.showError(checkbox, 'Failed to remove product');
          });
      }
    },

    updateBundleButtonState() {
      const isAnyChecked = Array.from(this.elements.checkboxes).some(cb => cb.checked);
      if (isAnyChecked) {
        this.elements.bundleButton.classList.remove('disabled');
      } else {
        this.elements.bundleButton.classList.add('disabled');
      }
    },
    initAddBundleButton() {
      // Wait for cart sync to finish before updating button state
      this.syncCheckboxesWithCart(() => {
        this.updateBundleButtonState();

        // Add change listeners only after sync
        this.elements.checkboxes.forEach(checkbox => {
          checkbox.addEventListener('change', this.updateBundleButtonState.bind(this));
        });
      });

      // Click handler
      this.elements.bundleButton.addEventListener('click', () => {
        if (!this.elements.bundleButton.classList.contains('disabled')) {
          const closeButton = document.querySelector('.upsell-modal-close');
          if (closeButton) {
            closeButton.click();
          }
        }
      });
    },
    Cart: {
      addProduct(variantId, quantity) {
        return new Promise((resolve, reject) => {
          try {
            const properties = {
              '_discount': UpsellSystem.config.discountText,
              '_upsell': 'true'
            };

            Shopify.addItem(variantId, quantity,
              item => {
                this.updateUI();
                resolve(item);
              },
              error => {
                reject(error);
              },
              properties
            );
          } catch (error) {
            reject(error);
          }
        });
      },

      removeProduct(variantId) {
        return new Promise((resolve, reject) => {
          try {
            Shopify.getCart(cart => {
              const lineItem = cart.items.find(item => item.id.toString() === variantId.toString());

              if (!lineItem) {
                reject(new Error('Product not found in cart'));
                return;
              }

              Shopify.changeItem(lineItem.key, 0,
                cart => {
                  this.updateUI();
                  resolve(cart);
                },
                error => {
                  reject(error);
                }
              );
            });
          } catch (error) {
            reject(error);
          }
        });
      },

      updateUI() {
        if (window.theme && theme.miniCart) {
          theme.miniCart.updateElements();
          theme.miniCart.generateCart();
        }
      }
    },

    UI: {
      showLoader(checkbox) {
        if (!document.getElementById('bt-upsell-spinner-style')) {
          const style = document.createElement('style');
          style.id = 'bt-upsell-spinner-style';
          style.textContent = '@keyframes bt-upsell-spin { to { transform: rotate(360deg); } }';
          document.head.appendChild(style);
        }

        checkbox.style.opacity = '0';
        checkbox.style.pointerEvents = 'none';

        const checkboxContainer = checkbox.closest('.upsell-product-checkbox-container');
        let loader = checkboxContainer.querySelector('.bt-upsell-checkbox-loader');

        if (!loader) {
          loader = document.createElement('div');
          loader.className = 'bt-upsell-checkbox-loader';
          loader.innerHTML = '<div class="bt-upsell-spinner" role="status" style="width: 18px; height: 18px; border: 2px solid currentColor; border-right-color: transparent; border-radius: 50%; animation: bt-upsell-spin 0.75s linear infinite;"></div>';
          loader.style.position = 'absolute';
          loader.style.top = '50%';
          loader.style.left = '50%';
          loader.style.transform = 'translate(-50%, -50%)';
          checkboxContainer.style.position = 'relative';
          checkboxContainer.appendChild(loader);
        } else {
          loader.style.display = 'block';
        }
      },

      hideLoader(checkbox) {
        checkbox.style.opacity = '1';
        checkbox.style.pointerEvents = 'auto';

        const checkboxContainer = checkbox.closest('.upsell-product-checkbox-container');
        const loader = checkboxContainer.querySelector('.bt-upsell-checkbox-loader');

        if (loader) {
          loader.style.display = 'none';
        }
      },

      showError(checkbox, message) {
        const checkboxContainer = checkbox.closest('.upsell-product-checkbox-container');
        let errorElement = checkboxContainer.querySelector('.bt-upsell-checkbox-error');

        if (!errorElement) {
          errorElement = document.createElement('div');
          errorElement.className = 'bt-upsell-checkbox-error';
          errorElement.style.color = 'red';
          errorElement.style.fontSize = '10px';
          errorElement.style.position = 'absolute';
          errorElement.style.bottom = '-15px';
          errorElement.style.left = '0';
          errorElement.style.width = '100px';
          checkboxContainer.appendChild(errorElement);
        }

        errorElement.textContent = message;

        setTimeout(() => {
          errorElement.textContent = '';
        }, UpsellSystem.config.errorDisplayTime);
      }
    }
  };

  UpsellSystem.init();
});